import { render, staticRenderFns } from "./supplier-cla-view.vue?vue&type=template&id=5781321b"
import script from "./supplier-cla-view.vue?vue&type=script&lang=js"
export * from "./supplier-cla-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports